import React, { FC, useRef, useState } from "react";

import SidebarAccount from "./SidebarAccount";

const SidebarAccountContainer: FC = () => {
  const anchorEl = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);

  return <SidebarAccount open={open} setOpen={setOpen} anchorEl={anchorEl} />;
};

export default SidebarAccountContainer;
